export default {"src":"/_next/static/media/visibility_icon.eeeae829.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};